
import Vue from 'vue'

export default Vue.extend({
  data: () => ({
    gcLoading: false,
    unpinAllLoading: false
  }),

  methods: {
    async freeUpStorage() {
      this.gcLoading = true

      await this.$accessor.ipfs.freeUpStorage()

      this.gcLoading = false
    },

    async unpinAll() {
      this.unpinAllLoading = true

      await this.$accessor.pins.unpinAll()

      this.unpinAllLoading = false
    },

    async deleteAll() {
      await this.unpinAll()
      await this.freeUpStorage()
    }
  }
})
